AoPS.Utils.initKeyChain(AoPS, "Ebooks", "Models", "Chapter");

AoPS.Ebooks.Models.Chapter = (function () {
	// Dependencies
	var EbkMBase = AoPS.Ebooks.Models.Base;

	return EbkMBase.BaseModel.extend({
		id_attribute: "fragment_id",
		defaults: {
			fragment_code: "",
			number: "",
			title_html: "",
			is_hard: false,
			order: -1,
			previous_id: 0,
			next_id: 0,
		},
		/** Additional attributes:
			book: Book model owning this one; guaranteed to be set
			sections: collection of Section models
		*/

		initialize: function () {
			var sections_coll = new EbkMBase.BaseCollection();

			this.set("paragraph_table", {});
			this.set("label_table", {});

			this.set("sections", sections_coll);
			sections_coll.setCreateFunction(
				_.bind(function (id) {
					var model = this.get("book").get("sections").getOrCreate(id);
					model.set("chapter", this);
					return model;
				}, this)
			);
			sections_coll.comparator = "order";
		},

		getTags: function () {
			var parent_tags = this.get("book").getTags();
			var number = this.get("number");
			var new_tag = number ? "Chapter " + number : this.get("title_html");
			if (parent_tags[0] === "Book") {
				new_tag = "Book " + new_tag;
			}
			return parent_tags.concat([new_tag]);
		},

		getTocNumber: function () {
			var number = this.get("number");
			if (number) {
				return number;
			} else if (this.get("previous_id")) {
				return "E";
			} else {
				return "C";
			}
		},

		// Available options:
		//   full: set to true to show a full title, e.g. "Chapter X: TITLE"
		//     instead of "X. TITLE"
		//   plain: set to true to return plain text, with no HTML.
		getNumberTitle: function (options) {
			options = options || {};
			var number = this.get("number");
			var hard =
				this.get("is_hard") && !options.plain ? EbkMBase.HARD_HTML : "";
			var prefix;

			if (options.full && number) {
				prefix = "Chapter " + number + hard + ":";
			} else if (number) {
				prefix = number + hard + ".";
			} else {
				prefix = hard;
			}

			return prefix + (prefix.length ? " " : "") + this.get("title_html");
		},

		getRelativeSectionId: function (direction) {
			var chapters = this.get("book").get("chapters");
			var previous = chapters.get(this.get("previous_id"));
			var next = chapters.get(this.get("next_id"));

			if (direction < 0 && previous) {
				return previous.getFirstSectionId();
			} else if (direction > 0 && next) {
				return next.getFirstSectionId();
			} else if (direction === 0) {
				return this.getFirstSectionId();
			}
		},

		getFirstSectionId: function () {
			var first_section = this.get("sections").at(0);
			return first_section && first_section.id;
		},

		sortSections: function () {
			this.get("sections").sort();
		},
	});
})();
